var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 52,
    viewBox: "0 0 37 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2805_1271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6919 32.124H24.6286C23.406 32.124 22.4148 33.1152 22.4148 34.3378V47.9956C22.4148 49.2183 23.406 50.2094 24.6286 50.2094H29.6919C30.9146 50.2094 31.9057 49.2183 31.9057 47.9956V34.3378C31.9057 33.1152 30.9146 32.124 29.6919 32.124Z",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.829 26.1484C22.829 26.1484 26.8068 21.6606 30.9646 26.1484",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4128 28.7886C24.4128 28.7886 26.8967 26.2925 29.3806 28.7886",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4148 41.1672H4.0423C3.7417 41.1672 3.44404 41.108 3.16633 40.9929C2.88861 40.8779 2.63627 40.7093 2.42372 40.4967C2.21117 40.2842 2.04256 40.0318 1.92753 39.7541C1.8125 39.4764 1.75329 39.1787 1.7533 38.8781V4.07953C1.7533 3.47245 1.99446 2.89023 2.42373 2.46096C2.853 2.03169 3.43522 1.79053 4.0423 1.79053H33.22C33.8271 1.79053 34.4093 2.03169 34.8386 2.46096C35.2678 2.89023 35.509 3.47245 35.509 4.07953V38.8781C35.509 39.1787 35.4498 39.4764 35.3348 39.7541C35.2197 40.0318 35.0511 40.2842 34.8386 40.4967C34.626 40.7093 34.3737 40.8779 34.096 40.9929C33.8183 41.108 33.5206 41.1672 33.22 41.1672H31.9057",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18665 10.7466H29.0756",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18665 17.9014H29.0756",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18665 25.0562H19.0003",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18665 32.2109H15.8884",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2805_1271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 52,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons01);
export default __webpack_public_path__ + "static/media/icons-01.efd1bb03b664beb0d3e15e2a8bcf8b52.svg";
export { ForwardRef as ReactComponent };